function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
function sumConditionSatisfiersTotal(conditionsManager, discountTaxOrder) {
    var originalTotalPrice = Big(0);
    // Iterate over condition-satisfying products to determine originalTotalPrice and totalQuantity
    _.forEach(conditionsManager.satisfiers, function(param) {
        var item = param.item, quantity = param.quantity;
        var _item_mixAndMatch;
        var adjustedBasePrice = Big(((_item_mixAndMatch = item.mixAndMatch) === null || _item_mixAndMatch === void 0 ? void 0 : _item_mixAndMatch.adjustedBasePrice) || item.basePrice || 0);
        originalTotalPrice = originalTotalPrice.add(// Multiply basePrice by the tax mult to account for taxes in the menu or from POS for taxesFirst setting
        adjustedBasePrice.times(discountTaxOrder === 'taxesFirst' ? item.basePriceMult || 1 : 1).times(quantity));
    });
    return originalTotalPrice;
}
function removeItemForOverride(param) {
    var conditionSatisfiers = param.conditionSatisfiers, items = param.items;
    var itemKeyToRemove = _.keys(conditionSatisfiers)[0];
    var __filter = _sliced_to_array(_.filter(items, [
        'key',
        itemKeyToRemove
    ]), 1), itemToBeAltered = __filter[0];
    var restOfItems = _.reject(items, [
        'key',
        itemKeyToRemove
    ]);
    if (itemToBeAltered.quantity - 1 < 1) {
        return restOfItems;
    }
    restOfItems.push(_object_spread_props(_object_spread({}, itemToBeAltered), {
        quantity: itemToBeAltered.quantity - 1
    }));
    return restOfItems;
}
var issueItemsForAPriceRewards = function(bogoCalcsData, bogoSpecial, conditionsManager, discountTaxOrder, items, redemptionIndex) {
    var itemsForAPrice = bogoSpecial.itemsForAPrice, specialId = bogoSpecial.specialId;
    // since we're calling this function again on ln56 we need another check here to make sure we're not dividing by 0
    if (!conditionsManager.satisfied) {
        return {};
    }
    var discountedTotalPrice = Big((itemsForAPrice === null || itemsForAPrice === void 0 ? void 0 : itemsForAPrice.value) || 0);
    var originalTotalPrice = sumConditionSatisfiersTotal(conditionsManager, discountTaxOrder);
    var targetIndividualDiscountPercentage = originalTotalPrice.minus(discountedTotalPrice).div(originalTotalPrice);
    // If the discount would raise the price of the items rather than lower it, rerun the conditionsManager without the cheapest item
    if (targetIndividualDiscountPercentage.lte(0)) {
        // add util func here to remove only 1 qty of an item to send back in, if zero remove item
        var itemsOverride = removeItemForOverride({
            conditionSatisfiers: conditionsManager.satisfiers,
            items: items
        });
        var ref;
        ref = conditionsManager.evaluate({
            itemsOverride: itemsOverride
        }), conditionsManager.satisfiers = ref.satisfiers, conditionsManager.satisfied = ref.satisfied, ref;
        return issueItemsForAPriceRewards(bogoCalcsData, bogoSpecial, conditionsManager, discountTaxOrder, itemsOverride, redemptionIndex);
    }
    var rewardsSatisfiers = {};
    // Iterate over items to determine applicableQuantity & maximum individualDiscount while preserving order
    _.forEach(items, function(item) {
        var conditionSatisfier = conditionsManager.satisfiers[item.key];
        if (!_.isNil(conditionSatisfier)) {
            var _item_mixAndMatch;
            var quantity = conditionSatisfier.quantity;
            var adjustedBasePrice = Big(((_item_mixAndMatch = item.mixAndMatch) === null || _item_mixAndMatch === void 0 ? void 0 : _item_mixAndMatch.adjustedBasePrice) || item.basePrice || 0);
            var discount = adjustedBasePrice.times(discountTaxOrder === 'taxesFirst' ? item.basePriceMult || 1 : 1).times(targetIndividualDiscountPercentage);
            if (discount.gt(adjustedBasePrice)) {
                discount = adjustedBasePrice;
            }
            var rewardId = itemsForAPrice === null || itemsForAPrice === void 0 ? void 0 : itemsForAPrice._id;
            var redemptionNumber = redemptionIndex + 1;
            var rewardIdKey = "".concat(rewardId, "__").concat(redemptionNumber);
            rewardsSatisfiers[item.key] = {
                item: item,
                quantity: quantity,
                rewards: _define_property({}, rewardIdKey, {
                    quantity: quantity,
                    reward: {
                        _id: rewardId,
                        dollarDiscount: Big(discount),
                        itemsForAPrice: _object_spread({}, itemsForAPrice)
                    },
                    specialId: specialId,
                    discountStacking: bogoSpecial.discountStacking,
                    discountPrecedence: bogoSpecial.discountPrecedence,
                    stackingBehavior: bogoSpecial.stackingBehavior,
                    nonStackingBehavior: bogoSpecial.nonStackingBehavior,
                    settingsDerivedFrom: bogoSpecial.settingsDerivedFrom
                })
            };
        }
    });
    return rewardsSatisfiers;
};
export default issueItemsForAPriceRewards;
